var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIconGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 4.79285L11.2071 1.99994C11.1143 1.90708 11.004 1.83341 10.8827 1.78316C10.7614 1.7329 10.6313 1.70703 10.5 1.70703C10.3687 1.70703 10.2387 1.7329 10.1173 1.78316C9.99601 1.83341 9.88577 1.90708 9.79291 1.99994L8.14655 3.6463L8.14646 3.64639L8.14637 3.64648L2.29294 9.49991C2.19978 9.59255 2.12592 9.70275 2.07563 9.82412C2.02535 9.9455 1.99965 10.0757 2 10.207V12.9999C2.00031 13.2651 2.10576 13.5192 2.29323 13.7067C2.4807 13.8942 2.73488 13.9996 3 13.9999H5.79291C5.92429 14.0003 6.05443 13.9746 6.1758 13.9243C6.29717 13.874 6.40737 13.8002 6.5 13.707L14 6.20703C14.1873 6.01934 14.2924 5.76505 14.2924 5.49993C14.2924 5.23482 14.1873 4.98053 14 4.79285ZM12 6.79285L9.20711 3.99994L10.5 2.70703L13.2929 5.49994L12 6.79285Z",
    fill: "#676C7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconGray);
export default __webpack_public_path__ + "static/media/editIconGray.f1630ba9b3478fa7b6bef6593ae7b2b7.svg";
export { ForwardRef as ReactComponent };